import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'

// Portal page data - reset by resetPortalState on every login (see resetPortalStores)
const defaultState = () => ({
  serviceList: [],
  searchData: {
    loading: false,
    org_id: 0,
    customer_type_id: 0,
    service_category_id: 0
  }
})

const state = defaultState()
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPortalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
